/**
 * @exports PieChart
 * @fileoverview The file define the PieChart graphique
 * @date 2022-08-23
 * @version 2.0 
 * @author Combes Hugo
 */

/*Import necessaries librairies*/
import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import {Chart, ArcElement, Tooltip, Legend} from 'chart.js'
Chart.register(ArcElement, Tooltip, Legend);
  
class PieChart extends Component{
    render(){
      return (
        <div >
            <Pie data={this.props.data} options={this.props.options} />
        </div>
      )
    }
  }
  
export default PieChart;
